module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Domain: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.domain_uuid),
      expression: "domain_uuid"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.domain_uuid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Domains")]), _vm._v(" "), _vm._l((_vm.domain_data), function(entry) {
    return _c('option', {
      key: entry[0],
      domProps: {
        "value": entry[0]
      }
    }, [_vm._v(_vm._s(entry[1]))])
  })], 2), _c('br'), _vm._v("\n  Min face height: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.min_face_height),
      expression: "min_face_height"
    }],
    domProps: {
      "value": (_vm.min_face_height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.min_face_height = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Update"
    },
    on: {
      "click": function($event) {
        _vm.setValues()
      }
    }
  }), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_c('b', [_vm._v(_vm._s(this.err))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c66d05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DomainSelector.vue
// module id = 294
// module chunks = 1